"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  This function has 2 roles :
    - filter all external links in fullText
    - avoid having an empty fullText
 */
var filterFullText = function (fullText) {
    var linkReg = /<a[^>]*href="[^#][^>]*>/g;
    var matches = fullText.match(linkReg);
    var newText = fullText;
    try {
        // try to remove only external links
        if (matches === null || matches === void 0 ? void 0 : matches.length) {
            matches.forEach(function (match) {
                var index = newText.indexOf(match);
                if (index > 0) {
                    var before = newText.slice(0, index);
                    var after = newText.slice(index + match.length);
                    newText = before + after.replace('</a>', '');
                }
            });
        }
    }
    catch (e) {
        // if error, remove all links
        console.error('Problem in filterFullText');
        return newText.replace(/<a[^>]*>/g, '').replace(/<\/a>/g, '') || '<p></p>';
    }
    return newText || '<p></p>';
};
exports.default = filterFullText;
//# sourceMappingURL=filterFullText.js.map